import React from 'react';
import PropTypes from 'prop-types';
import CardPianiValore, { TipoCardPianiValore } from '../CardPianiValore';
import { StatoUfficioPDE } from '../../Shared/Profilo/usePianoEccellenza';

export default function RiempimentoEsclusivaEccellenza({ statoUfficio }) {
  if (statoUfficio === StatoUfficioPDE.PDE_ATTIVO) {
    return (
      <CardPianiValore
        tipo={TipoCardPianiValore.Eccellenza}
        messaggio={<p>Grazie al Piano Eccellenza potrai fare anche quesiti di tipo normativo.</p>}
      />
    );
  }
  return (
    <CardPianiValore
      tipo={TipoCardPianiValore.Unicita}
      messaggio={(
        <div>
          <p><b>Promozione</b></p>
          <p>
            Attivando il Piano Eccellenza avrai in <b>regalo</b> il Piano Unicità per tutto il 2025
          </p>
        </div>
      )}
    />
  );
}

RiempimentoEsclusivaEccellenza.propTypes = {
  statoUfficio: PropTypes.string.isRequired,
};

RiempimentoEsclusivaEccellenza.defaultProps = {
};
